<span class="dialog__title">
        <ng-content></ng-content>
    </span>
<div class="dialog__close">
    <ui-square-icon-button mat-dialog-close="">
        <mat-icon fontIcon="close"></mat-icon>
    </ui-square-icon-button>
</div>

